import type { ChatStore } from "../Store";
import type { BreakTransformerType } from "@/Modules/Transformers/Break";

import BreaksApiConnector from "@/Services/TherapyApi/Breaks";
import BreakTransformer from "@/Modules/Transformers/Break";

import { unixUTC } from "@/Utils/Date";
import { hasValue } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";

class ReloadCurrentBreakActionHandler {
  constructor(
    private readonly chatStore: ChatStore,
    private readonly breaksApiConnector: BreaksApiConnector = new BreaksApiConnector(),
    private readonly breakTransformer: BreakTransformerType = BreakTransformer
  ) {}

  public async handle(roomId: string) {
    if (hasValue(this.chatStore.rooms[roomId])) {
      const { user } = this.chatStore.rooms[roomId];
      const unixTime = unixUTC();

      if (isValidString(user.customerUuid)) {
        const breaks = await this.breaksApiConnector.getBreaks(user.customerUuid);
        const currentBreak = breaks.find((b) => b.created_at < unixTime && b.end_at > unixTime);

        this.chatStore.rooms[roomId].currentBreak = hasValue(currentBreak)
          ? this.breakTransformer.toDomain(currentBreak)
          : undefined;
      }
    }
  }
}

export default ReloadCurrentBreakActionHandler;
